import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, {Suspense} from "react";
import "./components/_common/i18n"
import ProjectThemeProvider from "./components/_themes/ProjectThemeProvider";
import Routes from "./Routes";

const App = () => {
    return (

        <ProjectThemeProvider>
            <Suspense fallback={(<div>Loading</div>)}>
                <Routes/>
            </Suspense>
        </ProjectThemeProvider>
    );
}

export default App;
